{
  "title": "Color Spray",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level illusion",
  "level": 1,
  "castingTime": "1 action",
  "range": "Self (15-foot cone)",
  "components": "V, S, M (a pinch of powder or sand that is colored red, yellow, and blue)",
  "duration": "1 round",
  "description": [
    "A dazzling array of flashing, colored light springs from your hand. Roll 6d10, the total is how many hit points of creatures this spell can effect. Creatures in a 15-foot cone originating from you are affected in ascending order of their current hit points (ignoring unconscious creatures and creatures that can’t see).",
    "Starting with the creature that has the lowest current hit points, each creature affected by this spell is blinded until the end of your next turn. Subtract each creature’s hit points from the total before moving on to the creature with the next lowest hit points. A creature’s hit points must be equal to or less than the remaining total for the creature to be affected.",
    "At Higher Levels. When you cast this spell using a spell slot of 2nd level or higher, roll an additional 2d10 for each slot level above 1st."
  ],
  "spellLists": ["bard", "arcane-trickster", "sorcerer", "wizard"]
}
